/* eslint-disable no-restricted-syntax */
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';

import SweetAlert from 'react-bootstrap-sweetalert';
import {
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import OneClickButton from '../../../components/form/button';
import addNotification from '../../../components/notification';
import Table from '../../../components/table/Table';

import {
  getAllCrossdockings,
  cancelCrossdocking,
} from '../../../app/store/actions/crossdocking';

import Permissions from '../../../app/services/permissions';
import ROUTES from '../../../config/routes';

import FormatHelpers from '../../../helpers/format';
import CrossdockingHelpers from '../../../helpers/crossdocking';
import PrintVolumeAssemblyLabel from '../../../components/printLabel/volumeAssembly';

class CrossdockingMonitor extends React.Component {
  constructor(props) {
    super(props);

    this.breadcrumb = [
      {
        value: (
          <>
            <i className="fas fa-home fa-fw m-t-10 m-r-5" />
            {' '}
            {I18n.t('BEE12' /* Início */)}
          </>
        ),
      },
      { value: I18n.t('BEE1400' /* Movimentação */) },
      { value: I18n.t('BEE36' /* Recebimento */) },
      { value: I18n.t('BEE4355' /* Monitor de Cross-Docking */), active: true },
    ];

    this.state = {
      checked: {},
      checkedSheetIds: [],
      crossdockingList: [],
      showConfirmSeparation: false,
      showCancelCrossdocking: false,
      defaultPageSize: 10,
      defaultSorted: [{ id: 'productCode', desc: true }],
      showVolumeAssembly: false,
      orderNumberVolumeAssembly: '',
      outboundRangeIdVolumeAssembly: '',
      outboundRangeProductIdVolumeAssembly: '',
      inboundOrderChecked: [],
    };

    this.tableColumns = [
      {
        Header: I18n.t('BEE436' /* Selecionar */),
        accessor: 'action',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        filterable: false,
        sortable: false,
        Cell: (row) => (
          <div style={{ textAlign: 'center' }}>
            <input
              type="checkbox"
              checked={this.state.checked[row.original.id] || false}
              onChange={() => this.singleSelection(row.original)}
            />
          </div>
        ),
      },
      {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (rows) => {
          const { outboundOrder, status } = rows.original;
          return (
            <div style={{ textAlign: 'center' }}>
              <button className="btn btn-default btn-xs" type="button">
                {I18n.t('BEE55' /* Ações */)}
              </button>
              {!Permissions.checkPermission(
                ROUTES.P_FINALIZE_CROSSDOCKING_PICKING,
              ) && (
              <UncontrolledButtonDropdown>
                <DropdownToggle color="default" caret className="btn-xs" />
                <DropdownMenu>
                  {status === 3 && (
                  <DropdownItem onClick={() => this.showModalVolumeAssembly(
                    outboundOrder.orderNumber,
                    outboundOrder.ranges[0].id,
                    outboundOrder.products[0].outboundRangeProduct[0].id,
                  )}
                  >
                    {I18n.t('BEE4388' /* Fechar Volume */)}
                  </DropdownItem>
                  )}
                </DropdownMenu>
              </UncontrolledButtonDropdown>
              )}
            </div>
          );
        },
      },
      {
        Header: I18n.t('BEE145' /* Filial */),
        accessor: 'branchCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 80,
      },
      {
        Header: I18n.t('BEE225' /* Produto */),
        accessor: 'productCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
      },
      {
        Header: I18n.t('BEE4360' /* Documento de Entrada */),
        accessor: 'inboundOrderNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
      },
      {
        Header: I18n.t('BEE1808' /* Pedido Cliente */),
        accessor: 'customerOrderCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
      },
      {
        Header: I18n.t('BEE50' /* Cliente */),
        accessor: 'customer',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
      },
      {
        Header: I18n.t('BEE441' /* Quantidade */),
        accessor: 'quantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      },
      {
        Header: I18n.t('BEE4432' /* Conferência - Entrada */),
        accessor: 'inboundQuantityCheck',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      },
      {
        Header: I18n.t('BEE3506' /* Stage */),
        accessor: 'stage',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
      },
      {
        Header: I18n.t('BEE1904' /* Documento de Saída */),
        accessor: 'outboundOrderNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
      },
      {
        Header: I18n.t('BEE482' /* Alocada */),
        accessor: 'allocatedQuantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      },
      {
        Header: I18n.t('BEE2040' /* Separado */),
        accessor: 'pickedQuantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      },
      {
        Header: I18n.t('BEE4433' /* Conferência - Saída */),
        accessor: 'outboundQuantityCheck',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      },
      {
        Header: I18n.t('BEE224' /* Status */),
        accessor: 'status',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        Cell: (row) => (
          <div>
            <span>{CrossdockingHelpers.crossdockingStatus(row.value)}</span>
          </div>
        ),
        Filter: ({ onChange }) => (
          <select
            type="text"
            style={{ width: '100%' }}
            onChange={(event) => { onChange(event.target.value); }}
          >
            <option value="">{I18n.t('BEE793' /* Todos */)}</option>
            <option value={1}>{CrossdockingHelpers.crossdockingStatus(1)}</option>
            <option value={2}>{CrossdockingHelpers.crossdockingStatus(2)}</option>
            <option value={3}>{CrossdockingHelpers.crossdockingStatus(3)}</option>
            <option value={4}>{CrossdockingHelpers.crossdockingStatus(4)}</option>
            <option value={5}>{CrossdockingHelpers.crossdockingStatus(5)}</option>
            <option value={6}>{CrossdockingHelpers.crossdockingStatus(6)}</option>
          </select>
        ),
      },
    ];
  }

  componentDidMount() {
    this.getCrossdockingList();
  }

  singleSelection = (selection) => {
    const { checked } = this.state;
    checked[selection.id] = !checked[selection.id];
    this.setState({ checked: { ...checked } });
  };

  multipleSelection = (selectionOption) => {
    const { checked } = this.state;
    const data = this.reactTable.getResolvedState().sortedData;
    if (data && data.length > 0) {
      for (let index = 0; index < data.length; index += 1) {
        const element = data[index]._original;
        checked[element.id] = selectionOption;
      }
      this.setState({ checked: { ...checked } });
    }
  };

  validChecked = (type) => {
    const { checked, crossdockingList } = this.state;

    if (!Object.keys(checked).length) {
      addNotification(
        'danger',
        I18n.t('BEE4355' /* Monitor de Cross-Docking */),
        I18n.t('BEE4113' /* Nenhum produto/endereço selecionado */),
        'top-right',
      );
    } else {
      const checkedSheetIds = [];
      const inboundOrderChecked = [];
      for (const index in checked) {
        if (checked[index]) {
          const { inboundOrder } = crossdockingList.find((obj) => obj.id === Number(index));
          inboundOrderChecked.push(inboundOrder.orderNumber);
          checkedSheetIds.push(index);
        }
      }
      if (checkedSheetIds.length) {
        this.setState({
          checkedSheetIds: [...checkedSheetIds],
          inboundOrderChecked: [...inboundOrderChecked],
        });
        if (type === 'confirm') {
          this.showConfirmSeparationModal();
        } else {
          this.showCancelCrossdockingModal();
        }
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4355' /* Monitor de Cross-Docking */),
          I18n.t('BEE4113' /* Nenhum produto/endereço selecionado */),
          'top-right',
        );
      }
    }
  };

  showModalVolumeAssembly = async (orderNumber, outboundRangeId, outboundRangeProductId) => {
    this.setState({
      showVolumeAssembly: true,
      orderNumberVolumeAssembly: orderNumber,
      outboundRangeIdVolumeAssembly: outboundRangeId,
      outboundRangeProductIdVolumeAssembly: outboundRangeProductId,
    });
  };

  getCrossdockingList = async () => {
    try {
      const crossdockingList = await this.props.getAllCrossdockings();

      this.setState({
        crossdockingList: [...(crossdockingList || [])],
        checked: {},
      });
    } catch (err) {
      this.setState({ crossdockingList: [] });
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = error.details
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;
        addNotification(
          'danger',
          I18n.t('BEE4355' /* Monitor de Cross-Docking */),
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4355' /* Monitor de Cross-Docking */),
          I18n.t('BEE1969' /* Erro ao buscar dados */),
          'top-right',
        );
      }
    }
  };

  showConfirmSeparationModal = async () => {
    this.setState({
      showConfirmSeparation: true,
    });
  };

  showCancelCrossdockingModal = async () => {
    this.setState({
      showCancelCrossdocking: true,
    });
  };

  confirmSeparation = async () => {
    try {
      this.getCrossdockingList();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = error.details
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;
        addNotification(
          'danger',
          I18n.t('BEE4355' /* Monitor de Cross-Docking */),
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4355' /* Monitor de Cross-Docking */),
          I18n.t('BEE4396' /* Erro ao confirmar a separação */),
          'top-right',
        );
      }
    } finally {
      this.setState({
        showConfirmSeparation: false,
      });
    }
  };

  cancelCrossdocking = async () => {
    const { checkedSheetIds, inboundOrderChecked } = this.state;

    try {
      await this.props.cancelCrossdocking(checkedSheetIds);

      addNotification(
        'success',
        I18n.t('BEE4355' /* Monitor de Cross-Docking */),
        I18n.t(
          'BEE4380',
          {
            0: inboundOrderChecked.join(', '),
          }, /* O Cross-Docking do documento %{0} foi cancelado com sucesso. */
        ),
        'top-right',
      );

      this.getCrossdockingList();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = error.details
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;
        addNotification(
          'danger',
          I18n.t('BEE4355' /* Monitor de Cross-Docking */),
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4355' /* Monitor de Cross-Docking */),
          I18n.t('BEE4379' /* Erro ao cancelar Cross-Docking. */),
          'top-right',
        );
      }
    } finally {
      this.setState({
        showCancelCrossdocking: false,
      });
    }
  };

  render() {
    const {
      showConfirmSeparation,
      showCancelCrossdocking,
      defaultPageSize,
      defaultSorted,
      crossdockingList,
      checkedSheetIds,
      showVolumeAssembly,
      orderNumberVolumeAssembly,
      outboundRangeIdVolumeAssembly,
      outboundRangeProductIdVolumeAssembly,
    } = this.state;

    return (
      <>
        <Table
          ref={(r) => {
            this.reactTable = r && r.reactTable;
          }}
          downloadCSV
          panelHeaderProps={{
            onClickReload: this.getCrossdockingList,
          }}
          breadcrumb={this.breadcrumb}
          headerTitle={I18n.t('BEE4355' /* Monitor de Cross-Docking */)}
          wikiHelp=""
          actionButtons={(
            <div className="ml-auto">
              {(!Permissions.checkPermission(ROUTES.P_CANCEL_CROSSDOCKING)
                || !Permissions.checkPermission(
                  ROUTES.P_FINALIZE_CROSSDOCKING_PICKING,
                )) && (
                <>
                  <button
                    type="button"
                    className="btn btn-120 btn-secondary p-5 m-5"
                    onClick={() => this.multipleSelection(true)}
                  >
                    {I18n.t('BEE1908' /* Marcar Todos */)}
                  </button>

                  <button
                    type="button"
                    className="btn btn-120 btn-secondary p-5 m-5"
                    onClick={() => this.multipleSelection(false)}
                  >
                    {I18n.t('BEE1909' /* Desmarcar Todos */)}
                  </button>
                </>
              )}
              {!Permissions.checkPermission(ROUTES.P_CANCEL_CROSSDOCKING) && (
                <OneClickButton
                  type="button"
                  className="btn btn-danger p-5 m-5"
                  onClick={() => this.validChecked('cancel')}
                >
                  {I18n.t('BEE4378' /* Cancelar Cross-Docking */)}
                </OneClickButton>
              )}
            </div>
          )}
          filterable
          data={crossdockingList}
          columns={this.tableColumns}
          expander
          defaultPageSize={defaultPageSize}
          defaultSorted={defaultSorted}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
          getTrProps={(state, rowInfo) => {
            if (rowInfo && rowInfo.row) {
              return {
                style: {
                  color: rowInfo.original.status === 3 ? 'green' : 'black',
                },
              };
            }
            return {};
          }}
        />
        {showConfirmSeparation && (
          <SweetAlert
            info
            showCancel
            cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
            confirmBtnText={I18n.t('BEE1849' /* Continuar */)}
            confirmBtnBsStyle="primary"
            cancelBtnBsStyle="default"
            title={I18n.t('BEE101' /* Você tem certeza? */)}
            onConfirm={this.confirmSeparation}
            onCancel={() => this.setState({
              showConfirmSeparation: false,
              checkedSheetIds: [],
              inboundOrderChecked: [],
            })}
          >
            {I18n.t(
              'BEE4405',
              {
                0: checkedSheetIds.length,
              }, /* Serão separadas %{0} fichas de Cross-Docking. Deseja continuar? */
            )}
          </SweetAlert>
        )}

        {showCancelCrossdocking && (
          <SweetAlert
            info
            showCancel
            cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
            confirmBtnText={I18n.t('BEE1849' /* Continuar */)}
            confirmBtnBsStyle="primary"
            cancelBtnBsStyle="default"
            title={I18n.t('BEE101' /* Você tem certeza? */)}
            onConfirm={this.cancelCrossdocking}
            onCancel={() => this.setState({
              showCancelCrossdocking: false,
              checkedSheetIds: [],
            })}
          >
            {I18n.t(
              'BEE4406',
              {
                0: checkedSheetIds.length,
              }, /* Serão canceladas %{0} fichas de Cross-Docking. Deseja continuar? */
            )}
          </SweetAlert>
        )}
        {(showVolumeAssembly && (
          <PrintVolumeAssemblyLabel
            modalMode
            openChangeModal={showVolumeAssembly}
            closeModalPrintVolumeAssemblyLabel={() => {
              this.setState({ showVolumeAssembly: false });
            }}
            orderNumber={orderNumberVolumeAssembly}
            outboundRangeId={outboundRangeIdVolumeAssembly}
            outboundRangeProductId={outboundRangeProductIdVolumeAssembly}
            getCrossdockingList={this.getCrossdockingList}
          />
        ))}
      </>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  getAllCrossdockings: () => dispatch(getAllCrossdockings()),
  cancelCrossdocking: (crossdockingIds) => dispatch(cancelCrossdocking(crossdockingIds)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(CrossdockingMonitor));
